module.exports = __webpack_public_path__ + "static/media/btn_0.7659065e.png";